<template>
  <div class="wrapper">
    <div class="consultia-sidebar">
      <div class="consultia-sidebar__header">
        <div class="consultia-sidebar__logo">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        </div>
        <div>
          <div class="consultia-sidebar__titulo">ConsultIA</div>
          <div class="consultia-sidebar__sub">datos.gov.co</div>
        </div>
      </div>

      <div class="consultia-sidebar__seccion">¿QUÉ QUIERES CONSULTAR?</div>

      <router-link to="/consulta-secop" class="consultia-card" :class="{ 'consultia-card--activo': $route.path === '/consulta-secop' }">
        <div class="consultia-card__icono consultia-card__icono--azul">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        </div>
        <div class="consultia-card__texto">
          <div class="consultia-card__titulo">Análisis de la Demanda</div>
          <div class="consultia-card__sub">Buscar contratos públicos</div>
        </div>
      </router-link>

      <router-link to="/consulta-unspsc" class="consultia-card" :class="{ 'consultia-card--activo': $route.path === '/consulta-unspsc' }">
        <div class="consultia-card__icono consultia-card__icono--coral">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>
        </div>
        <div class="consultia-card__texto">
          <div class="consultia-card__titulo">Consulta UNSPSC</div>
          <div class="consultia-card__sub">Buscar códigos UNSPSC</div>
        </div>
      </router-link>

      <!-- ── NUEVO: Datos SECOP ── -->
      <router-link to="/datos-secop" class="consultia-card" :class="{ 'consultia-card--activo': $route.path === '/datos-secop' }">
        <div class="consultia-card__icono consultia-card__icono--verde">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="20" x2="18" y2="10"/>
            <line x1="12" y1="20" x2="12" y2="4"/>
            <line x1="6"  y1="20" x2="6"  y2="14"/>
          </svg>
        </div>
        <div class="consultia-card__texto">
          <div class="consultia-card__titulo">
            Análisis de la Oferta
            <span class="consultia-badge-new">Nuevo</span>
          </div>
          <div class="consultia-card__sub">Gráficas para estudios de sector</div>
        </div>
      </router-link>
      <!-- ── Datos del Sector ── -->
      <router-link to="/datos-sector" class="consultia-card" :class="{ 'consultia-card--activo': $route.path === '/datos-sector' }">
        <div class="consultia-card__icono consultia-card__icono--morado">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/>
          </svg>
        </div>
        <div class="consultia-card__texto">
          <div class="consultia-card__titulo">
            Entorno Económico
            <span class="consultia-badge-new">Nuevo</span>
          </div>
          <div class="consultia-card__sub">Indicadores, empresas y proyectos</div>
        </div>
      </router-link>

      <!-- ── Plan Anual de Adquisiciones ── -->
      <router-link to="/consulta-paa" class="consultia-card" :class="{ 'consultia-card--activo': $route.path === '/consulta-paa' }">
        <div class="consultia-card__icono consultia-card__icono--naranja">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
            <polyline points="10 9 9 9 8 9"/>
          </svg>
        </div>
        <div class="consultia-card__texto">
          <div class="consultia-card__titulo">
            Plan de Adquisiciones
            <span class="consultia-badge-new">Nuevo</span>
          </div>
          <div class="consultia-card__sub">PAA publicados en SECOP II</div>
        </div>
      </router-link>

    </div>

    <div class="main-panel">
      <top-navbar />
      <dashboard-content @click.native="toggleSidebar" />
      <content-footer />
    </div>
  </div>
</template>

<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";

export default {
  name: "MainLayout",
  components: { TopNavbar, ContentFooter, DashboardContent },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
};
</script>

<style lang="scss">
$azul: #0A2463;
$coral: #E63946;
$blanco: #ffffff;
$fondo: #F8FAFC;

.wrapper {
  min-height: 100vh;
  display: flex;
  background: $fondo;
}

/* ================= SIDEBAR CUSTOM ================= */
.consultia-sidebar {
  width: 260px;
  min-width: 260px;
  background: $blanco;
  border-right: 1px solid #e2e8f0;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-shadow: 4px 0 16px rgba(10,36,99,0.06);
}

.consultia-sidebar__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 4px 16px;
  border-bottom: 1px solid #e2e8f0;
  margin-bottom: 8px;
}

.consultia-sidebar__logo {
  width: 38px;
  height: 38px;
  background: $azul;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $blanco;
  flex-shrink: 0;
}

.consultia-sidebar__titulo {
  font-size: 16px;
  font-weight: 800;
  color: $azul;
  line-height: 1.2;
}

.consultia-sidebar__sub {
  font-size: 11px;
  color: #94a3b8;
  font-weight: 500;
}

.consultia-sidebar__seccion {
  font-size: 10px;
  font-weight: 700;
  color: #94a3b8;
  letter-spacing: 0.8px;
  padding: 4px 4px 2px;
  margin-top: 4px;
}

/* ================= CARDS ================= */
.consultia-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 12px;
  border-radius: 12px;
  border: 1.5px solid #e2e8f0;
  background: $blanco;
  cursor: pointer;
  text-decoration: none !important;
  transition: all 0.18s ease;
  color: inherit;
}

.consultia-card:hover {
  border-color: $azul;
  background: #f0f4ff;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(10,36,99,0.1);
}

.consultia-card--activo {
  border-color: $azul !important;
  background: #eef2ff !important;
  box-shadow: 0 4px 16px rgba(10,36,99,0.12);
}

.consultia-card__icono {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.consultia-card__icono--azul {
  background: #e8edf8;
  color: $azul;
}

.consultia-card__icono--coral {
  background: #fde8ea;
  color: $coral;
}

/* ── NUEVO: icono verde para Datos SECOP ── */
.consultia-card__icono--verde {
  background: #e6f4ea;
  color: #28a745;
}

.consultia-card--activo .consultia-card__icono--azul {
  background: $azul;
  color: $blanco;
}

.consultia-card--activo .consultia-card__icono--coral {
  background: $coral;
  color: $blanco;
}

/* ── NUEVO: icono verde activo ── */
.consultia-card--activo .consultia-card__icono--verde {
  background: #28a745;
  color: $blanco;
}

.consultia-card__titulo {
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.2;
}

.consultia-card__sub {
  font-size: 12px;
  color: #94a3b8;
  margin-top: 2px;
}

/* ── NUEVO: badge "Nuevo" ── */
.consultia-badge-new {
  display: inline-block;
  font-size: 0.58rem;
  font-weight: 700;
  padding: 1px 6px;
  border-radius: 999px;
  background: #d4edda;
  color: #1a7a32;
  margin-left: 6px;
  vertical-align: middle;
  letter-spacing: 0.03em;
  line-height: 1.6;
}

/* ================= MAIN PANEL ================= */
.main-panel {
  background: $fondo !important;
  flex: 1 1 auto;
  min-height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.navbar {
  background: $blanco !important;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 2px 8px rgba(10,36,99,0.06);
}

footer,
.content-footer {
  background: $blanco !important;
  border-top: 1px solid #e2e8f0;
  color: $azul !important;
}
// Ocultar el sidebar original del plugin (ya no lo usamos)
.side-bar,
.sidebar {
  display: none !important;
}

// El panel principal debe ocupar todo menos nuestro sidebar custom
.wrapper {
  display: flex;
}

.consultia-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  z-index: 100;
  overflow-y: auto;
}

.main-panel {
  margin-left: 260px !important;
  width: calc(100% - 260px) !important;
}

.main-panel > .content {
  padding: 20px 20px 20px 20px !important;
  margin-top: 0 !important;
}

.main-panel {
  margin-left: 260px !important;
  width: calc(100% - 260px) !important;
  padding-top: 0 !important;
}
.consultia-card__icono--morado {
  background: #ede9fe;
  color: #6d28d9;
}
.consultia-card--activo .consultia-card__icono--morado {
  background: #6d28d9;
  color: $blanco;
}
.consultia-card__icono--naranja {
  background: rgba(234, 88, 12, 0.12);
  color: #ea580c;
}
.consultia-card--activo .consultia-card__icono--naranja {
  background: #ea580c;
  color: $blanco;
}
</style>